import React from 'react';
import PropTypes from 'prop-types';
import style from './actionable-placeholder.module.css';
import { Button } from '../button';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';

/**
 * @param {object} props
 * @param {React.ReactNode} props.title
 * @param {React.ReactNode} props.description
 * @param {React.ReactNode} [props.buttonContent]
 * @param {React.ReactNode} [props.actionDescription]
 * @param {Function} [props.action]
 * @param {React.ReactNode} [props.svg]
 * @param {string} [props.altText]
 */
export const ActionablePlaceholder = ({
  title,
  description,
  buttonContent = null,
  actionDescription = null,
  action = null,
  svg = null,
  altText = null,
}) => {
  return (
    <div className={style.placeholder}>
      <div className={style.content}>
        <img alt={altText} src={svg} />
        <div className={style.title}>{title}</div>
        <div className={style.message}>{description}</div>
        {buttonContent && (
          <div className={style.button}>
            <Button onClick={action} theme='primary'>
              {buttonContent}
            </Button>
          </div>
        )}
        {actionDescription && <div className={style.message}>{actionDescription}</div>}
      </div>
    </div>
  );
};

ActionablePlaceholder.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  buttonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actionDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  action: PropTypes.func,
  buttonTheme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  svg: PropTypes.node,
  altText: PropTypes.string,
};
